import styled from '@emotion/styled'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { DraggableFieldsList } from './draggable-fields-list'
import { GovernanceField, SetFormProps } from '../types'
import { reorderFields } from '../utils'
import { t } from '@lingui/core/macro'

interface OrderFieldsProps {
  fields: GovernanceField[]
  setForm: SetFormProps
  removeFieldFromState: (fieldId: string, checked: boolean) => void
}

const SectionSubtitle = styled.p`
  font-size: 10px;
  opacity: 0.5;
`

const FieldPosition = styled.p`
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin: 0;
  margin-bottom: 10px;
`

export function OrderFields({ fields, setForm, removeFieldFromState }: OrderFieldsProps) {
  function removeField(fields, fieldId) {
    removeFieldFromState(fieldId, false)

    return fields.filter(field => field.concatenation_field_id !== fieldId)
  }

  function onDragEnd(result) {
    if (!result.destination) {
      return
    }

    const reorderedFields = reorderFields(fields, result.source.index, result.destination.index)

    setForm(prev => {
      return {
        ...prev,
        concatenation_governance: {
          ...prev.concatenation_governance,
          concatenation_governance_patterns: reorderedFields,
        },
      }
    })
  }

  function handleRemoveField(fieldId) {
    const items = removeField(fields, fieldId)

    setForm(prev => {
      return {
        ...prev,
        concatenation_governance: {
          ...prev.concatenation_governance,
          concatenation_governance_patterns: items,
        },
      }
    })
  }

  return (
    <div>
      <div>
        <div style={{ display: 'flex', gap: '20px' }}>
          <div style={{ textAlign: 'center' }}>
            <SectionSubtitle>{t`Position`}</SectionSubtitle>
            {fields.map((_, index) => (
              <FieldPosition key={index}>{index + 1}</FieldPosition>
            ))}
          </div>

          <div style={{ width: '100%' }}>
            <SectionSubtitle>{t`Field`}</SectionSubtitle>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="list">
                {provided => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <DraggableFieldsList fields={fields} onRemoveField={handleRemoveField} />
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>
    </div>
  )
}
